import {
    getErrorNotificationMessage,
    getWarningNotificationMessage,
} from '../../components/helper/NotificationMessage';
import { showErrorComponent } from '../actions/ComponentAction';
import {
    fetchPendingReferralPaymentsFailure,
    fetchPendingReferralPaymentsStart,
    fetchPendingReferralPaymentsSuccess,
    fetchReferralPaymentsHistoryFailure,
    fetchReferralPaymentsHistorySuccess,
    fetchReferredUsersFailure,
    fetchReferredUsersSuccess,
    referralWithdrawalFailure,
    referralWithdrawalSuccess,
} from '../actions/ReferralAction';
import { createNotification } from 'react-redux-notify';
import { select, put, takeLatest, all } from 'redux-saga/effects';
import { push } from "../../helpers/navigation/navigationService";
import {
    FETCH_PENDING_REFERRAL_PAYMENTS_START,
    FETCH_REFERRAL_PAYMENTS_HISTORY_START,
    FETCH_REFERRED_USERS_START,
    REFERRAL_WITHDRAWAL_START,
} from '../actions/ActionConstant';
import axiosClient from '../../helpers/services/payment';
import { checkLogoutStatus } from '../actions/ErrorAction';
import { fetchWalletDetailsStart } from '../actions/WalletAction';
import { initiateTablePayoutStart, updatePayoutInfo } from '../actions/PayoutAction';

function* fetchReferralPendingPaymentsAPI(action) {
    try {
        const { page = 1, limit = 10 } = action.data || {};
        const response = yield axiosClient.get(
            `/api/referral/pending-payment?page=${page}&limit=${limit}`,
        );

        if (response.data.success) {
            yield put(fetchPendingReferralPaymentsSuccess(response.data.data));
        } else {
            const notificationMessage = getErrorNotificationMessage(response.data.error);
            yield put(createNotification(notificationMessage));
        }
    } catch (error) {
        yield put(fetchPendingReferralPaymentsFailure(error));
        if (error?.response?.status !== 400) {
            yield put(
                showErrorComponent({
                    error,
                    status: error?.response?.status || 500,
                }),
            );
        }
        const notificationMessage = getErrorNotificationMessage(error.response?.data?.error);
        yield put(createNotification(notificationMessage));
    }
}

function* fetchReferralPaymentsHistoryAPI(action) {
    try {
        const { page = 1, limit = 10 } = action.data || {};
        const response = yield axiosClient.get(`/api/referral/history?page=${page}&limit=${limit}`);

        if (response.data.success) {
            yield put(fetchReferralPaymentsHistorySuccess(response.data.data));
        } else {
            const notificationMessage = getErrorNotificationMessage(response.data.error);
            yield put(createNotification(notificationMessage));
        }
    } catch (error) {
        yield put(fetchReferralPaymentsHistoryFailure(error));
        if (error?.response?.status !== 400) {
            yield put(
                showErrorComponent({
                    error,
                    status: error?.response?.status || 500,
                }),
            );
        }
        const notificationMessage = getErrorNotificationMessage(error.response?.data?.error);
        yield put(createNotification(notificationMessage));
    }
}

function* fetchReferredUsersAPI(action) {
    try {
        const { page = 1, limit = 10 } = action.data || {};
        const response = yield axiosClient.get(`/api/referral/users?page=${page}&limit=${limit}`);

        if (response.data.success) {
            yield put(fetchReferredUsersSuccess({
                ...response.data.data,
                inputData: action.data,
            }));
        } else {
            const notificationMessage = getErrorNotificationMessage(response.data.error);
            yield put(createNotification(notificationMessage));
            yield put(fetchReferredUsersFailure(response.data));
        }
    } catch (error) {
        yield put(fetchReferredUsersFailure(error));
        if (error?.response?.status !== 400) {
            yield put(
                showErrorComponent({
                    error,
                    status: error?.response?.status || 500,
                }),
            );
        }
        const notificationMessage = getErrorNotificationMessage(error.response?.data?.error);
        yield put(createNotification(notificationMessage));
    }
}

function* referralWithdrawalAPI(action) {
    try {
        const response = yield axiosClient.post('/api/referral/withdraw');
        if (response.data.success) {
            yield put(referralWithdrawalSuccess(response.data));

            const requiresAdminApproval = response.data?.admin_approval_required;
            const withdrawId = response.data?.withdrawal_id;
            const withdrawalUniqueId = response.data?.withdrawal_unique_id;


            // To refetch the latest data for pending referral payments
            yield put(fetchPendingReferralPaymentsStart({ page: 1, limit: 10 }))
            if (requiresAdminApproval && withdrawId && withdrawalUniqueId ) {
                yield put(fetchWalletDetailsStart());
                const notificationMessage = getWarningNotificationMessage(
                    'Your transaction was successfully submitted for processing. You will be notified with further updates',
                );
                yield put(createNotification(notificationMessage));
                yield push('/wallet');
            } else if (!requiresAdminApproval && withdrawId  && withdrawalUniqueId) {
                yield put(updatePayoutInfo({ amount: response?.data?.totalCalculatedAmount }));
                yield put(initiateTablePayoutStart(withdrawalUniqueId));
            }
        } else {
            yield put(checkLogoutStatus(response.data));
            const notificationMessage = getErrorNotificationMessage(response.data.error);
            yield put(referralWithdrawalFailure(response.data));
            yield put(createNotification(notificationMessage));
        }
    } catch (error) {
        const errorMessage =
            error.response.data.errors?.[0]?.message || 'Something went wrong while withdrawing';

        yield put(referralWithdrawalFailure(error));
        if (error?.response?.status !== 400) {
            yield put(
                showErrorComponent({
                    error: errorMessage,
                    status: error?.response?.status || 500,
                }),
            );
        }
        const notificationMessage = getErrorNotificationMessage(errorMessage);
        yield put(createNotification(notificationMessage));
    }
}

export {
    fetchReferralPendingPaymentsAPI,
    fetchReferralPaymentsHistoryAPI,
    fetchReferredUsersAPI,
    referralWithdrawalAPI,
};

export default function* pageSaga() {
    yield all([
        takeLatest(FETCH_PENDING_REFERRAL_PAYMENTS_START, fetchReferralPendingPaymentsAPI),
        takeLatest(FETCH_REFERRAL_PAYMENTS_HISTORY_START, fetchReferralPaymentsHistoryAPI),
        takeLatest(FETCH_REFERRED_USERS_START, fetchReferredUsersAPI),
        takeLatest(REFERRAL_WITHDRAWAL_START, referralWithdrawalAPI),
    ]);
}
